module.exports = __webpack_public_path__ + "img/A48DA4_E8DDE8_C9B7C9_D4C2D4-256px.8ffeef9e.png";